import { connect } from 'react-redux';
import { compose, withHandlers, withState } from 'recompose';
import { t } from '../../../../modules/infra/i18n';

import ProductSaleChargeButton from '../components/ProductSaleChargeButton';
import { getCanCharge, getIsFetching, getTotal } from '../../validated/selectors';
import { getIsFetching as paymentIsFetching } from '../../payment/reducer/isFetching/selectors';
import withCardCharge from '../../payment/hoc/withCardCharge';
import { getCustomerCard } from '../../customer/selectors';
import { getCard } from '../../payment/reducer/card/selectors';
import withNotifications from '../../../common/withNotifications';

export default compose(
  withCardCharge,
  withNotifications,
  withState('clicked', 'setClicked', false),
  connect((state, props) => ({
    card: getCustomerCard(state) || getCard(state),
    disabled: !getCanCharge(state) || getIsFetching(state) || paymentIsFetching(state) || props.clicked,
    totalAmount: getTotal(state),
  })),
  withHandlers({
    charge: (props) => () => {
      if (!props.card) {
        props.addNotification({
          level: 'error',
          message: t('common:notifications.payment_error_message'),
          title: t('common:notifications.payment_error_title'),
        });
        return;
      }

      props.setClicked(true);
      props.cardCharge(props.card);
    },
  })
)(ProductSaleChargeButton);
